import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle2, Coins, PartyPopper, ArrowRight } from 'lucide-react';

interface SuccessStepProps {
  amount: number;
  credits: number;
  onClose: () => void;
}

export function SuccessStep({ amount, credits, onClose }: SuccessStepProps) {
  return (
    <div className="space-y-6 text-center">
      {/* Success Animation */}
      <div className="relative mx-auto w-24 h-24">
        <div className="absolute inset-0 rounded-full bg-green-500/20 animate-ping" />
        <div className="absolute inset-0 rounded-full bg-green-500/10" />
        <CheckCircle2 className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-14 w-14 text-green-500" />
      </div>

      {/* Title */}
      <div className="space-y-2">
        <div className="flex items-center justify-center gap-2">
          <PartyPopper className="h-5 w-5 text-primary" />
          <h3 className="font-bold text-2xl">Deposit Successful!</h3>
          <PartyPopper className="h-5 w-5 text-primary scale-x-[-1]" />
        </div>
        <p className="text-muted-foreground">
          Your payment has been confirmed on the blockchain.
        </p>
      </div>

      {/* Details */}
      <Card className="bg-green-500/5 border-green-500/20">
        <CardContent className="py-6 space-y-4">
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground">Amount received:</span>
            <span className="font-semibold text-lg">{amount} USDT</span>
          </div>
          <div className="h-px bg-border" />
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground">Credits added:</span>
            <span className="font-bold text-xl text-primary flex items-center gap-1.5">
              <Coins className="h-5 w-5" />
              +{credits.toLocaleString()}
            </span>
          </div>
        </CardContent>
      </Card>

      {/* Message */}
      <p className="text-sm text-muted-foreground">
        Your credits are now available. Use them to unlock AI predictions!
      </p>

      {/* Action Button */}
      <Button 
        className="w-full" 
        size="lg"
        onClick={onClose}
      >
        Back to Site
        <ArrowRight className="h-4 w-4 ml-2" />
      </Button>
    </div>
  );
}
